const loadCSS = (url, async = true) => {
    const head = document.querySelector('head'),
        link = document.createElement('link');
    link.type = 'text/css';
    link.rel = 'stylesheet';
    link.async = async;
    link.href = url;
    head.appendChild(link);
};

export default loadCSS;
